import axios from '../utils/axiosInstance';

export const fetchSectorAPI = async () => axios.get('Sector/');




